module.exports = __webpack_public_path__ + "static/img/2_speak.282d984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/2_speak.svg
// module id = m29K
// module chunks = 10